export const COOKIES_NAME = {
  LOGIN_USER_NAME : "login_user_name",
  LOGIN_MAIL_ADDRESS : "login_mail_address",
  LOGIN_ROLE_ID : "login_role_id",
  LOGIN_SECOND_AUTH_TOKEN : "second_auth_token",
  REGISTER_USER_TOKEN : "register_user_token",
  PHONE_NUMBER : "phone_number",
};
export const SESSION_NAME = {
  ADMIN_URL_REDIRECT: "admin_url_redirect",
  USER_URL_REDIRECT: "user_url_redirect",
};

export const LOCAL_STORAGE_NAME = {
  NEW_USER_CONTACTS: "new_user_contacts",
  NEW_ADMIN_CONTACTS: "new_admin_contacts",
};